module.exports = __webpack_public_path__ + "img/PK_Asset_Info_Web3.6a50ffbb.png";